import { Request } from 'commons/utils/request'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'

import { useUserReportContext } from '../context/UserReportContext'

export const PageActions = () => {
  const { state } = useUserReportContext()

  return (
    <ButtonGroup margin="small">
      <ExportCSVButton reportName="User" url={Request.urls.bank.portalReportUserCSV} parametersForm={state} />
    </ButtonGroup>
  )
}
